import { render, staticRenderFns } from "./DictionaryNew.vue?vue&type=template&id=6c9ee2f0&"
import script from "./DictionaryNew.vue?vue&type=script&lang=js&"
export * from "./DictionaryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports